import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppInstallService {
  installable$ = new BehaviorSubject<boolean>(false);

  setInstallable(value: boolean): void {
    this.installable$.next(value);
  }

  installApp(): void {
    if (window.installEvent) {
      window.installEvent.prompt();
    }
  }
}

declare global {
  interface Window {
    installEvent: any;
  }
}